import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import CardObject from "../../../components/global/CardObject";
import CardProject from "../../../components/global/CardProject";
import { ChromePicker, CirclePicker } from "react-color";
import CardName from "../../../components/global/CardName";
import LabelModalRemove from "./LabelModalRemove";
import LabelModalArchive from "./LabelModalArchive";
import LabelModalArchiveCancel from "./LabelModalArchiveCancel";
import gammaPng from '../../../files/system/Color_Gamma.png';
import axios from "axios";
import ButtonAction from "../../../components/global/ButtonAction";
import CardDescription from "../../../components/card/CardDescription";
import useOutsideClick from "../../../util/useOutsideClick";
import ErrorAdd from "../../../util/ErrorAdd";

function LabelModal({ show, onHide, model }) {

    const stateLabelList = useSelector((state) => state.labelList);
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки
    const [heightBody, setHeightBody] = useState(0);

    useEffect(() => {
        if (stateSize.desktop !== true) {
            setHeightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 70);
        }

    }, [stateSize]);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    const [modalRemoveShow, setModalRemoveShow] = useState(false);
    const [modalArchiveShow, setModalArchiveShow] = useState(false);
    const [modalArchiveCancelShow, setModalArchiveCancelShow] = useState(false);

    const [formObject, setFormObject] = useState([]);
    const [formProject, setFormProject] = useState([]);
    const [colorShow, setColorShow] = useState(false);

    useEffect(() => {
        setFormColor(model.Color === null ? '#dddfe0' : model.Color);
        setFormObject(stateLabelList.listObject.filter(a => a.ID_Label === model.ID).map((item) => { return item.ID_Object }));
        setFormProject(stateLabelList.listProject.filter(a => a.ID_Label === model.ID).map((item) => { return item.ID_Project }));
    }, [stateLabelList.listObject, stateLabelList.listProject, model]);

    //Изменение объекта
    function objectHundler(checked, id) {
        if (checked == true) {
            setFormObject([...formObject.filter(a => a !== id), id]);
        }
        else {
            setFormObject([...formObject.filter(a => a !== id)]);
        }
    }
    //Изменение проекта
    function projectHandler(selected) {
        setFormProject(selected);
    }

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);

    function updateName(val) {
        setLoadingName(true);
        setLogName(null);
        if (val === null) {
            setLogName('Введите название параметра');
            setLoadingName(false);
        }
        else {
            axios.post('/api_tracker/label/updateName', { ID_Label: model.ID, Name: val })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoadingName(false);
                        setHideName(true);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoadingName(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoadingName(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    const [hideDescription, setHideDescription] = useState(false);
    const [logDescription, setLogDescription] = useState(null);
    const [loadingDescription, setLoadingDescription] = useState(false);
    function updateDescription(val) {
        setLoadingDescription(true);
        setLogDescription(null);

        axios.post('/api_tracker/label/updateDescription', { ID_Label: model.ID, Description: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoadingDescription(false);
                    setHideDescription(true);
                }
                else {
                    setLogDescription(res.data.Error);
                    setLoadingDescription(false);
                }
            })
            .catch((err) => {
                setLogDescription('Неизвестная ошибка!');
                setLoadingDescription(false);
                ErrorAdd(err, window.location.href);
            });

    }
    function updateAllObject(val) {
        setLoading(true);

        //setFormObjectAll(val);

        axios.post('/api_tracker/label/updateAllObject', { ID_Label: model.ID, All_Object: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });

    }
    function updateAllProject(val) {
        setLoading(true);

        // setFormProjectAll(val);

        axios.post('/api_tracker/label/updateAllProject', { ID_Label: model.ID, All_Project: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });

    }

    //Изменение цвета
    const [formColor, setFormColor] = useState(undefined);
    const [loadingColor, setLoadingColor] = useState(false);
    const [logColor, setLogColor] = useState(null);
    const colorOutsideClick = useOutsideClick((e) => {
        updateColor(formColor);
        setColorShow(false);
    });
    function updateColor(val) {
        setLoadingColor(true);
        setLogColor(null);
        //setFormColor(val);

        axios.post('/api_tracker/label/updateColor', { ID_Label: model.ID, Color: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoadingColor(false);
                }
                else {
                    setLogColor(res.data.Error);
                    setLoadingColor(false);
                }
            })
            .catch((err) => {
                setLogColor('Неизвестная ошибка!');
                setLoadingColor(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Изменение объекта
    function objectHundler(checked, id) {
        if (checked == true) {
            axios.post('/api_tracker/label/objectAdd', { ID_Label: model.ID, ID_Object: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setFormObject([...formObject.filter(a => a !== id), id]);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            axios.post('/api_tracker/label/objectRemove', { ID_Label: model.ID, ID_Object: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setFormObject([...formObject.filter(a => a !== id)]);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    //Изменение проекта
    function projectHandler(id, val) {

        if (val === true) {
            axios.post('/api_tracker/label/projectAdd', { ID_Label: model.ID, ID_Project: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            axios.post('/api_tracker/label/projectRemove', { ID_Label: model.ID, ID_Project: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            {modalRemoveShow === true && (
                <LabelModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} onHideLabel={() => onHide()} model={model} />
            )}
            {modalArchiveShow === true && (
                <LabelModalArchive show={modalArchiveShow} onHide={() => setModalArchiveShow(false)} onHideLabel={() => onHide()} model={model} />
            )}
            {modalArchiveCancelShow === true && (
                <LabelModalArchiveCancel show={modalArchiveCancelShow} onHide={() => setModalArchiveCancelShow(false)} onHideLabel={() => onHide()} model={model} />
            )}

            {stateSize.desktop === true ? (
                <Modal show={show} onHide={onHide} size="lg" >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="row mb-15" >
                            <div className="col-md-7" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 120, overflow: 'auto' }}>
                                <div className="mb-3">
                                    <CardName name={model.Name} onlyRead={false} placeholder='Название параметра...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                </div>
                                <div className="mb-3">
                                    <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                                </div>
                                <label className="form-label">Цвет метки</label>
                                <CirclePicker width="100%" color={formColor} colors={["#5c636a", "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]} onChange={e => updateColor(e.hex)} />

                                <div className="mt-15 d-flex" style={{ cursor: 'pointer' }} onClick={() => { setColorShow(!colorShow) }}>
                                    <div className=" " style={{ backgroundColor: formColor, width: '100px', height: '30px', borderRadius: '5px' }} >

                                    </div>
                                    <img src={gammaPng} height={30} className="ml-5" />
                                    {loadingColor === true && <div className="loader_01"></div>}
                                </div>
                                {colorShow === true && (
                                    <div ref={colorOutsideClick} style={{ width: '225px', textAlign: 'center' }}>
                                        <ChromePicker className="mt-15" color={formColor} onChange={e => setFormColor(e.hex)} disableAlpha={false} />
                                    </div>
                                )}
                            </div>
                            <div className="col-md-5" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 120, overflow: 'auto' }}>
                                <div className="card-block-title">Действия</div>
                                {
                                    model.ID_Status === 1 ? (
                                        <div key={1}>
                                            <div className="mt-5"><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                            <div className="mt-5"><ButtonAction typeBtn='archive' onClick={() => setModalArchiveShow(true)} /></div>
                                        </div>
                                    ) : (
                                        <div key={2}>
                                            <div className="mt-5"><ButtonAction typeBtn='cancel' textBtn='Отмена архивирования' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                        </div>
                                    )
                                }
                                <div className="card-block-title mt-20">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                                <div className="mt-15">
                                    <CardObject checkedList={formObject} changeHandler={objectHundler} all={model.All_Object} allHandler={(val) => updateAllObject(val)} />
                                </div>
                                <div className="card-block-title mt-20">ДОСТУПНЫЕ ПРОЕКТЫ</div>
                                <div className="mt-15">
                                    <CardProject selected={formProject} changeHandler={projectHandler} all={model.All_Project} allHandler={(val) => updateAllProject(val)} />
                                </div>
                            </div>
                        </div>
                        {log != null && (
                            <div className="form_error text-center">
                                {log}
                            </div>
                        )}
                    </Modal.Body>
                </Modal >
            ) : (
                <Modal show={show} onHide={onHide} size="lg" >
                    <Modal.Body>
                        <div ref={refHeader}>
                            <div style={{ display: 'flex' }}>
                                <CardName name={model.Name} onlyRead={false} placeholder='Название параметра...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                <div className="modal_close" style={{ marginLeft: 'auto' }} onClick={() => onHide()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            </div>
                        </div>
                        <div style={{ maxHeight: heightBody, overflow: 'auto' }}>
                            <div className="mb-3">
                                <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                            </div>
                            <label className="form-label">Цвет метки</label>
                            <CirclePicker width="100%" color={formColor} colors={["#5c636a", "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]} onChange={e => updateColor(e.hex)} />
                            <div className="mt-15 d-flex" style={{ cursor: 'pointer' }} onClick={() => { setColorShow(!colorShow) }}>
                                <div className=" " style={{ backgroundColor: formColor, width: '100px', height: '30px', borderRadius: '5px' }} >

                                </div>
                                <img src={gammaPng} height={30} className="ml-5" />
                                {loadingColor === true && <div className="loader_01"></div>}
                            </div>
                            {colorShow === true && (
                                <div ref={colorOutsideClick} style={{ width: '225px', textAlign: 'center' }}>
                                    <ChromePicker className="mt-15" color={formColor} onChange={e => setFormColor(e.hex)} disableAlpha={false} />
                                </div>
                            )}
                            <div className="card-block-title mt-20">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                            <div className="mt-15">
                                <CardObject checkedList={formObject} changeHandler={objectHundler} all={model.All_Object} allHandler={(val) => updateAllObject(val)} />
                            </div>
                            <div className="card-block-title mt-20">ДОСТУПНЫЕ ПРОЕКТЫ</div>
                            <div className="mt-15">
                                <CardProject selected={formProject} changeHandler={projectHandler} all={model.All_Project} allHandler={(val) => updateAllProject(val)} />
                            </div>
                        </div>
                        <div ref={refFooter}>
                            <hr></hr>
                            <div style={{ height: '55px' }}>
                                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                <div className="m_btn_block_footer" >
                                    {
                                        model.ID_Status === 1 ? (
                                            <div key={model.ID_Status}>
                                                <ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} />
                                                <ButtonAction typeBtn='archive' textBtn='Архив' onClick={() => setModalArchiveShow(true)} />
                                            </div>
                                        ) : (
                                            <div key={model.ID_Status}>
                                                <ButtonAction typeBtn='cancel' textBtn='Отмена' onClick={() => setModalArchiveCancelShow(true)} />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}

        </>
    );
}
export default LabelModal;
